import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../assets/css/benefits.css";
import CloseImage from "../assets/images/close.svg";
import CopyLinkIcon from "../assets/images/copylink.svg";
import CheckIcon from "../assets/images/check.svg";
import FbIcon from "../assets/images/fb.svg";
import TwitterIcon from "../assets/images/twitter.svg";
import ModalCTA from "./modalCTA";
import StandardFlow from "./standardFlow";
import CodeRewardFlow from "./codeRewardFlow";
import { useDispatch, useSelector } from 'react-redux';
import RewardRedemptionError from "./rewardRedemptionError";
import contentConfig from "../config/memberhubContents.json";
import { resetLocalStorage } from "../redux/data/dataActions";
import { getCurrentEnv } from "../utils/environment";
import { setRedeemRewardError } from "../redux/data/dataSlice";

function ModalImageDescription(props) {
    const dispatch = useDispatch();
    const [descriptionSection1, setDescriptionSection1] = useState("");
    const [descriptionSection2, setDescriptionSection2] = useState("");
    const [descriptionLength, setDescriptionLength] = useState(false);
    const [showSocialShareFooter, setShowSocialShareFooter] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);
    const redeemedReward = useSelector(state => state.data.redeemedReward);
    const redeemedRewardError = useSelector(state => state.data.redeemedRewardError);
    const isMobileView = useSelector(state => state.data.isMobileView);
    const shouldHideSocialShare = props.reward.extra_data && props.reward.extra_data.social_share === "0";

    const scrollRef = useRef();

    const executeScrolltoTop = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo(0, 0);
        }
    };

    const renderShadow = () => {
        console.log("renderShadow");
        let modalDescriptions = document.getElementsByClassName("modal-description");
        let modalFooters = document.getElementsByClassName("modal-footer");
        if (modalDescriptions.length > 0 && modalFooters.length > 0) {
            if (modalDescriptions[0].scrollHeight > modalDescriptions[0].clientHeight) {
                if (!modalDescriptions[0].className.includes("modal-description-shadow")) {
                    modalDescriptions[0].className += " modal-description-shadow";
                }
                if (!modalFooters[0].className.includes("modal-footer-shadow")) {
                    modalFooters[0].className += " modal-footer-shadow";
                }
            } else {
                if (modalDescriptions[0].className.includes("modal-description-shadow")) {
                    modalDescriptions[0].className = modalDescriptions[0].className.replace(" modal-description-shadow", "");
                }
                if (modalFooters[0].className.includes("modal-footer-shadow")) {
                    modalFooters[0].className = modalFooters[0].className.replace(" modal-footer-shadow", "");
                }
            }
        }
    };

    const renderShare = () => {
        const shareButton = <div className="modal-button-share" onClick={() => setShowSocialShareFooter(!showSocialShareFooter)}>Share</div>;
        if (!shouldHideSocialShare) {
            if (props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes") {
                if (props.getCodeClicked || codeAccessed(props.reward)) {
                    return shareButton;
                }
            } else {
                return shareButton;
            }
        }
        return;
    };

    const shareOnSocial = (e, socialType) => {
        e.preventDefault();

        const shareUrl = `${window.location.origin}/api/meta/benefits/${props.reward.id}`;
        console.log("shareUrl:", shareUrl);

        let shareText = (props.reward.extra_data && props.reward.extra_data.socialshare_copy) ? props.reward.extra_data.socialshare_copy : "";
        console.log("shareText:", shareText);

        let url = "";

        if (socialType === "copy") {
            navigator.clipboard.writeText(shareUrl);
            setLinkCopied(true);
        }
        else if (socialType === "facebook") {
            url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`;
        }
        else if (socialType === "twitter") {
            const defaultTwitterCopy = "Sign Up. Score Big with NBA ID.";
            url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText === "" ? defaultTwitterCopy : shareText)}`;
        }

        if (url) {
            console.log("url:", url);
            let shareWidth = 520;
            let shareHeight = 570;
            let shareLeft = (window.screen.width - shareWidth) / 2;
            let shareTop = (window.screen.height - shareHeight) / 2;
            window.open(url, "_blank", `location=yes,height=${shareHeight},width=${shareWidth},left=${shareLeft},top=${shareTop},scrollbars=yes,status=yes`);
        }
    };

    const codeAccessed = data => data.reference_id === "code_code" && data.redeemed && data.redeemed.codes;
    const isSoldOut = data => data.reference_id === "code_code" && !data.redeemed && data.extra_data && data.extra_data.sold_out === "1" && data.max_select_quantity === 0;

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const queryStatus = queryParams.get("status");
        if (queryStatus && queryStatus !== "200") {
            props.setGetCodeClicked(true);
            dispatch(setRedeemRewardError({
                status: "error",
                data: {
                    error: "amex_error"
                }
            }));
        }
        console.log("ModalImageDescription: status:", queryStatus);

        const handleResize = (event) => {
            renderShadow();
        };
        window.addEventListener("resize", handleResize, false);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, [props, dispatch]);

    useEffect(() => {
        if (props.reward.description) {
            let description = props.reward.description.replace(/\[section 2\]/gi, "[section 2]");
            if (description.includes("[section 2]")) {
                const rewardDescription = description.split("[section 2]");
                setDescriptionSection1(rewardDescription[0]);
                if(isSoldOut(props.reward) && props.reward.extra_data.sold_out_description) {
                    setDescriptionSection2(rewardDescription[1] + "<br />" + props.reward.extra_data.sold_out_description);
                } else {
                    setDescriptionSection2(rewardDescription[1]);
                }
            } else {
                setDescriptionSection1(description);
                if(isSoldOut(props.reward) && props.reward.extra_data.sold_out_description) {
                    setDescriptionSection2(props.reward.extra_data.sold_out_description);
                }
            }
        }
    }, [props.reward]);

    useEffect(() => {
        console.log("desc length:", props.reward.description.length)
        if (scrollRef.current) {
            const descriptionDivHeight = scrollRef.current.scrollHeight;
            // if (props.reward.description.length > 500) {
            console.log("Description div height:", descriptionDivHeight);
            if (descriptionDivHeight > 320) {
                setDescriptionLength(true);
            }
        }
        setTimeout(() => { renderShadow(); }, 50);
    }, [props.reward.description.length]);

    useEffect(() => {
        console.log("Invalid session: ", redeemedRewardError)
        if (props.getCodeClicked && redeemedRewardError && Object.keys(redeemedRewardError).length > 0 && redeemedRewardError.status === "error" && redeemedRewardError.errorCodes && redeemedRewardError.errorCodes[0] === "INVALID_SESSION") {
            console.log("inside reset local storage")
            resetLocalStorage();

            const currentEnv = getCurrentEnv();
            const envPath = currentEnv && currentEnv !== "prod" && currentEnv !== "uat" ? "-" + currentEnv : "";
            const loginPathUrl = `https://www${envPath}.nba.com/account/sign-in?redirect-to-membership-hub`;
            window.location.href = loginPathUrl;
        }
    }, [props.getCodeClicked, redeemedRewardError])

    useEffect(() => {
        if (props.getCodeClicked) {
            console.log("useEffect[props.getCodeClicked]");
            setTimeout(() => { renderShadow(); }, 50);
        }
    }, [props.getCodeClicked, redeemedReward.data]);

    return (
        <>
            <div className="modal-row">
                <div className="modal-image-column">
                    <img
                        src={props.reward.image}
                        style={{ opacity: props.reward.max_select_quantity === 0 || isSoldOut(props.reward) || codeAccessed(props.reward) ? 0.4 : 1 }}
                        alt=""
                    />
                    {!isSoldOut(props.reward) && props.reward.max_select_quantity === 0 && (props.reward.reference_id === "code_code" || props.reward.reference_id === "code_url") &&
                        <div className="modal-image-tag">
                            {contentConfig.accessed}
                        </div>
                    }
                    {codeAccessed(props.reward) &&
                        <div className="modal-image-tag">
                            {contentConfig.accessed}
                        </div>
                    }
                    {props.reward.max_select_quantity === 0 && props.reward.reference_id === "sweepstakes" &&
                        <div className="modal-image-tag">
                            {contentConfig.entered}
                        </div>
                    }
                    {props.reward.max_select_quantity !== 0 && props.reward.is_new &&
                        <div className="modal-image-tag">
                            {contentConfig.new}
                        </div>
                    }
                    {isSoldOut(props.reward) && !codeAccessed(props.reward) &&
                        <div className="modal-image-tag">
                            {props.reward.extra_data.sold_out_tag}
                        </div>
                    }
                </div>
                <div className="modal-column">
                    <div ref={scrollRef} className="modal-description">
                        <div className="modal-description-content">
                            {props.reward.reference_id === "standard" && <StandardFlow reward={props.reward} />}
                            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes" || props.reward.reference_id === "code_url") && props.getCodeClicked && Object.keys(redeemedReward).length > 0 && <CodeRewardFlow reward={props.reward} descriptionSection1={descriptionSection1} descriptionSection2={descriptionSection2} getCodeClicked={props.getCodeClicked} />}
                            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes" || props.reward.reference_id === "code_url") && !props.getCodeClicked && <CodeRewardFlow reward={props.reward} descriptionSection1={descriptionSection1} descriptionSection2={descriptionSection2} getCodeClicked={props.getCodeClicked} />}
                            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes" || props.reward.reference_id === "code_url") && props.getCodeClicked && redeemedRewardError && Object.keys(redeemedRewardError).length > 0 && <CodeRewardFlow reward={props.reward} descriptionSection1={descriptionSection1} descriptionSection2={descriptionSection2} getCodeClicked={props.getCodeClicked} />}
                            {!descriptionLength &&
                                <>
                                    {props.getCodeClicked && redeemedRewardError && Object.keys(redeemedRewardError).length > 0 && redeemedRewardError.status === "error" &&
                                        <RewardRedemptionError descriptionLength={descriptionLength} redemptionErrorMessage={redeemedRewardError.data.error === "frequency_cap_exceeded" ? contentConfig.redemptionErrorMessage : (redeemedRewardError.data.error === "amex_error" ? contentConfig.amexErrorMessage : contentConfig.invalidRewardErrorMessage)} />
                                    }
                                </>
                            }
                        </div>
                    </div>
                    <div className="modal-footer">
                        <ModalCTA reward={props.reward} getCodeClicked={props.getCodeClicked} setGetCodeClicked={props.setGetCodeClicked} setShowModal={props.setShowModal} descriptionLength={descriptionLength} executeScrolltoTop={executeScrolltoTop} />
                        {renderShare()}
                    </div>
                </div>
            </div>
            {!shouldHideSocialShare && showSocialShareFooter && !isMobileView && <div className="badge-modal-share">
                <div className="share-header">Congrats on earning this benefit! Share it with the world.</div>
                <div className="badge-modal-share-container">
                    <Link
                        to={{ pathname: `/benefits/${props.reward.id}`, search: window.location.search }}
                        reloadDocument="false"
                        data-track="click"
                        data-id="nba:membership-hub:social"
                        data-section="badges"
                        data-content="CopyLink"
                        data-type="social"
                        className="share-button" title="Copy Link" onClick={(e) => shareOnSocial(e, "copy")}>
                        {linkCopied ?
                            <>
                                <div className="icon-container link-copied">
                                    <img src={CheckIcon} alt="Link Copied" className="badge-modal-share-icon" />
                                </div>
                                <div className="site-name">Link Copied</div>
                            </>
                            :
                            <>
                                <div className="icon-container">
                                    <img src={CopyLinkIcon} alt="Copy Link" className="badge-modal-share-icon" />
                                </div>
                                <div className="site-name">Copy Link</div>
                            </>
                        }
                    </Link>
                    <Link
                        to={{ pathname: `/benefits/${props.reward.id}`, search: window.location.search }}
                        reloadDocument="false"
                        data-track="click"
                        data-id="nba:membership-hub:social"
                        data-section="badges"
                        data-content="Facebook"
                        data-type="social"
                        className="share-button" title="Share on Facebook" onClick={(e) => shareOnSocial(e, "facebook")}>
                        <div className="icon-container">
                            <img src={FbIcon} alt="Share on Facebook" className="badge-modal-share-icon" />
                        </div>
                        <div className="site-name">Facebook</div>
                    </Link>
                    <Link
                        to={{ pathname: `/benefits/${props.reward.id}`, search: window.location.search }}
                        reloadDocument="false"
                        data-track="click"
                        data-id="nba:membership-hub:social"
                        data-section="badges"
                        data-content="Twitter"
                        data-type="social"
                        className="share-button" title="Share on Twitter" onClick={(e) => shareOnSocial(e, "twitter")}>
                        <div className="icon-container">
                            <img src={TwitterIcon} alt="Share on Twitter" className="badge-modal-share-icon" />
                        </div>
                        <div className="site-name">X (Twitter)</div>
                    </Link>
                </div>
            </div>
            }
            {!shouldHideSocialShare && showSocialShareFooter && isMobileView && <div className="benefit-mobile-modal-share">
                <div className="benefit-mobile-modal-share-container">
                    <div className="share-modal-header">
                        <div className="share-modal-header-title">Share this benefit</div>
                        <div className="share-modal-header-close" onClick={() => { setShowSocialShareFooter(false) }}>
                            <img alt="close" src={CloseImage} />
                        </div>
                    </div>
                    <div className="benefit-mobile-modal-container-body">
                        <div className="share-header">Congrats on earning this benefit! Share it with the world.</div>
                        <div className="badge-modal-share-container">
                            <Link
                                to={{ pathname: `/benefits/${props.reward.id}`, search: window.location.search }}
                                reloadDocument="false"
                                data-track="click"
                                data-id="nba:membership-hub:social"
                                data-section="badges"
                                data-content="CopyLink"
                                data-type="social"
                                className="share-button" title="Copy Link" onClick={(e) => shareOnSocial(e, "copy")}>
                                {linkCopied ?
                                    <>
                                        <div className="icon-container link-copied">
                                            <img src={CheckIcon} alt="Link Copied" className="badge-modal-share-icon" />
                                        </div>
                                        <div className="site-name">Link Copied</div>
                                    </>
                                    :
                                    <>
                                        <div className="icon-container">
                                            <img src={CopyLinkIcon} alt="Copy Link" className="badge-modal-share-icon" />
                                        </div>
                                        <div className="site-name">Copy Link</div>
                                    </>
                                }
                            </Link>
                            <Link
                                to={{ pathname: `/benefits/${props.reward.id}`, search: window.location.search }}
                                reloadDocument="false"
                                data-track="click"
                                data-id="nba:membership-hub:social"
                                data-section="badges"
                                data-content="Facebook"
                                data-type="social"
                                className="share-button" title="Share on Facebook" onClick={(e) => shareOnSocial(e, "facebook")}>
                                <div className="icon-container">
                                    <img src={FbIcon} alt="Share on Facebook" className="badge-modal-share-icon" />
                                </div>
                                <div className="site-name">Facebook</div>
                            </Link>
                            <Link
                                to={{ pathname: `/benefits/${props.reward.id}`, search: window.location.search }}
                                reloadDocument="false"
                                data-track="click"
                                data-id="nba:membership-hub:social"
                                data-section="badges"
                                data-content="Twitter"
                                data-type="social"
                                className="share-button" title="Share on Twitter" onClick={(e) => shareOnSocial(e, "twitter")}>
                                <div className="icon-container">
                                    <img src={TwitterIcon} alt="Share on Twitter" className="badge-modal-share-icon" />
                                </div>
                                <div className="site-name">X (Twitter)</div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            }
        </>
    );
}

export default ModalImageDescription;
